import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDelivery } from '../../../../../hooks';
import { useNotificationReducer } from '../../../../../reducers';
import {
  Text,
  Container,
  LeftSection,
  ComposerButton,
} from '../Custom/MessageComposer';

const LocationComposer = () => {
  const { t } = useTranslation('full_page');

  const notification = useNotificationReducer();

  const { sendLocationMessage } = useDelivery();

  const [isSending, setIsSending] = useState(false);

  const handleSendLocation = () => {
    if (!navigator.geolocation) {
      notification.dispatch({
        type: notification.TYPES.SHOW_ERROR,
        message: t('send_location_error_message', { ns: 'bots' })
      });
      return;
    }

    setIsSending(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        sendLocationMessage(null, latitude, longitude);
        setIsSending(false);
      },
      () => {
        notification.dispatch({
          type: notification.TYPES.SHOW_ERROR,
          message: t('send_location_error_message', { ns: 'bots' })
        });
        setIsSending(false);
      }
    );
  };

  return (
    <Container>
      <LeftSection htmlFor="location-composer">
        <Text>{t('send_location_label')}</Text>
      </LeftSection>
      <ComposerButton
        aria-label={t('send_location_label')}
        onClick={handleSendLocation}
        disabled={isSending}
      >
        📍
      </ComposerButton>
    </Container>
  );
};

export default LocationComposer;
